import type { MonthCoverageFill } from "../utils";

export type SegmentPlay = {
  changed: boolean;
  from: number;
  origin: "left" | "right";
};

// Reviewed fills have no animation of their own, so they never join the sequence.
const ANIMATED_FILLS: MonthCoverageFill[] = ["full", "half-start", "half-end"];

// Only segments whose fill changed animate, continuing from where the previous fill ended.
export const planSegments = (fills: MonthCoverageFill[], previous: MonthCoverageFill[] | null): SegmentPlay[] =>
  fills.map((fill, index) => {
    const before = previous?.[index];
    const continuesFromHalf = fill === "full" && (before === "half-start" || before === "half-end");

    return {
      changed: ANIMATED_FILLS.includes(fill) && (previous === null || before !== fill),
      from: continuesFromHalf ? 0.5 : 0,
      origin: fill === "full" && before === "half-end" ? "right" : "left",
    };
  });
